import React from "react";

export default function MainSecFourMobile() {
  return (
    <div className="relative min-[769px]:hidden w-full h-[calc(100vh-300px)]">
      <div className="relative w-full h-[52vh] flex flex-col items-center justify-start bg-color-primary-C  rounded-bl-[20px] rounded-br-[20px] ">
        <div
          dir="rtl"
          className="w-full flex items-center justify-center mt-[80px] gap-x-[8px] font-font_primary_A text-[24px] text-color-primary-A"
        >
          <span className="text-color-primary-B">نوین</span>
          <span>در راه خدمت رسانی</span>
        </div>
        <img
          src="../assets/images/other/phones.png"
          className="absolute bottom-[-30px] scale-125 w-[25vh] h-[30vh] "
        />
      </div>
      <div className="w-full h-1/2 flex flex-col items-center justify-center mt-[80px] min-[390px]:mt-[40px] ">
        <div
          dir="rtl"
          className="w-full flex items-center justify-center  px-[20px]"
        >
          <p className="font-font_primary_A  text-[16px] text-color-primary-D text-justify">
            اپلیکیشن اسکارپین با بهره گیری از هوش مصنوعی تمام پارامترهای مصرفی
            خودرو شما را تحت نظارت دارد؛ به گونه ای که هر پارامتر مصرفی خودرو
            قبل از رسیدن به شرایط بحرانی به شما اطلاع داده می شود.
          </p>
        </div>
        <div className="w-full  flex items-center justify-center gap-x-[15px]  mt-[20px]">
          <button
            className="cursor-pointer"
            onClick={() => {
              window.open("https://scarpin.ir/l/SBAZ", "_blank");
            }}
          >
            <img
              src="../assets/images/other/cafe_bazar.svg"
              className="w-[135px] h-[50px] "
            />
          </button>
          <button
            className="cursor-pointer"
            onClick={() => {
              window.open("https://scarpin.ir/l/SWEB", "_blank");
            }}
          >
            <img
              src="../assets/images/other/pwa.svg"
              className="w-[135px] h-[50px] "
            />
          </button>
        </div>
      </div>
    </div>
  );
}
